import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';

import { LocationItemComponent } from '@app/components/project/project-locations/location-item/location-item.component';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { Location, SelectSingleLocationDialogData } from '@app/shared/types/models/location/location.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-select-single-location-dialog',
  templateUrl: './select-single-location-dialog.component.html',
  imports: [TranslatePipe, LocationItemComponent, MatDialogClose, UiDialogComponent, UiButtonComponent]
})
export class SelectSingleLocationDialogComponent implements OnInit {
  private readonly data: SelectSingleLocationDialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<SelectSingleLocationDialogComponent> = inject(MatDialogRef);

  protected selectedLocation?: Location;
  protected locations: Location[];
  protected isReadonly: boolean;
  protected showEditButton: boolean;
  protected isEmptyOptionEnabled: boolean;
  protected title: string;

  public ngOnInit(): void {
    this.locations = this.data.locations;
    this.selectedLocation = this.data.selectedLocation;
    this.isReadonly = false;
    this.showEditButton = this.data.showEditButton;
    this.isEmptyOptionEnabled = this.data.isEmptyOptionEnabled;
    this.title = this.data.title;
  }

  protected save(): void {
    this.dialogRef.close(this.selectedLocation);
  }
}
